import { Injectable, Injector } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { AgregationService } from '@ispm-client/modules/aggregator/services/aggregator.service';
import { CORE_ACTIONS } from '@ispm/core/constants/core-actions.constant';
import { tap } from 'rxjs/operators';


@Injectable()
export class AggregatorEffects {
  constructor(private injector: Injector, private actions$: Actions) { }

  @Effect({ dispatch: false})
  clearingQueryList = this.actions$.pipe(
    ofType(CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS),
    tap(() => this.getAggregatorService().clearQuerylist()));

  private getAggregatorService(): AgregationService {
    return this.injector.get(AgregationService);
  }
 }
